import { Pipe, PipeTransform } from '@angular/core';

import { clienteSituacoes } from '../cliente-situacao';

@Pipe({
    name: 'clienteSituacao'
})
export class ClienteSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return clienteSituacoes[index].nome;
        }
        return '';
    }
}
